package org.teddapp.project.ui.skills

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.tedd.db.Task
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.adaptive.WindowClass
import org.teddapp.project.ui.adaptive.WithWindowClass
import org.teddapp.project.ui.nav.NavIntent
import org.teddapp.project.ui.nav.PillarTabs
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.nav.TeddBottomNav
import org.teddapp.project.ui.nav.TeddNavRail
import org.teddapp.project.ui.settings.SettingsDrawerHost
import org.teddapp.project.ui.settings.rememberSettingsDrawer

/**
 * Compétences, troisième onglet du pilier Objectifs : ce que j'apprends, à côté de ce que
 * je vise (Objectifs) et de ce que je mène (Projets).
 *
 * Lancer une course depuis une étape de parcours passe par Focus : la demande y est
 * déposée, puis on s'y rend. Le minuteur n'a ainsi qu'un seul propriétaire.
 */
@Composable
fun SkillsScreen(
    repos: TeddRepositories,
    onNavigate: (Section) -> Unit = {},
    modifier: Modifier = Modifier,
    /** Un mot déjà cherché dans la compétence ouverte, pour les captures. */
    initialDetailSearch: String = "",
    /** Avec [initialDetailSearch] : ouvre le premier résultat d'entrée, pour les captures. */
    initialRevealFirst: Boolean = false,
) {
    val model = rememberSkillsModel(repos)
    androidx.compose.runtime.LaunchedEffect(initialDetailSearch) { if (initialDetailSearch.isNotEmpty()) model.detailSearch = initialDetailSearch }
    if (initialRevealFirst) androidx.compose.runtime.LaunchedEffect(model.selected?.skill?.id, model.stats.size) {
        val st = model.selected ?: return@LaunchedEffect
        findInSkill(textsOf(st, model), initialDetailSearch).firstOrNull { it.target != null }?.let { model.reveal(it.target) }
    }
    val startFocus: (Task, Int) -> Unit = { task, minutes ->
        NavIntent.launchFocus(task, minutes, skillId = model.selected?.skill?.id)
        onNavigate(Section.Focus)
    }
    WithWindowClass(modifier.fillMaxSize()) { wc ->
        if (wc == WindowClass.Compact) {
            Column(modifier = Modifier.fillMaxSize().background(TeddTokens.Bg).statusBarsPadding()) {
                PillarTabs(current = Section.Skills, onNavigate = onNavigate, compact = true, modifier = Modifier.padding(top = 12.dp, bottom = 4.dp))
                SkillsView(model = model, compact = true, modifier = Modifier.weight(1f), onNavigate = onNavigate, onStartFocus = startFocus)
                TeddBottomNav(active = Section.Skills, onNavigate = onNavigate, modifier = Modifier.navigationBarsPadding())
            }
        } else {
            val drawer = rememberSettingsDrawer()
            SettingsDrawerHost(drawer, onNavigate = onNavigate) {
                Row(modifier = Modifier.fillMaxSize().background(TeddTokens.Bg)) {
                    TeddNavRail(active = Section.Skills, onNavigate = onNavigate, onSettingsClick = drawer::open)
                    Column(modifier = Modifier.weight(1f).fillMaxSize()) {
                        PillarTabs(current = Section.Skills, onNavigate = onNavigate, compact = false)
                        SkillsView(model = model, compact = false, modifier = Modifier.weight(1f), onNavigate = onNavigate, onStartFocus = startFocus)
                    }
                }
            }
        }
    }
}
